<template>
  <section class="aviso">
    <div class="foto" :class="tipoPlanoConvertido">
      <img v-if="storePerfil.usuario" :src="`https://central-statics.nyc3.digitaloceanspaces.com/global/planos/${tipoPlanoConvertido}.png`" />
      <div class="fundo"></div>
    </div>
    <div class="texto">
      <h3>
        Plano
        <span>{{ tipoPlanoConvertido }} {{ exibirPlano(storePerfil.usuario?.assinatura?.plano) }}</span>
        está ativado
      </h3>
      <p v-if="storePerfil.usuario?.assinatura?.tipo !== 'free'">Ativo até {{ vencimento.dataFormatada || '' }}, {{ vencimento.diasRestantes || '' }} dias restantes</p>
      <p v-else>Assine um dos planos Unic para publicar suas Landing Pages</p>
    </div>
  </section>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useStorePerfil } from '@stores'

const storePerfil = useStorePerfil()

const vencimento = ref({
  dataFormatada: '--/--/----',
  diasRestantes: 'N/A'
})

const tipoPlanoConvertido = computed(() => {
  const tipo = storePerfil.usuario?.assinatura?.plano
  if (!tipo) return 'free'

  const tiposPlano = {
    expert: 'diamond',
    pro: 'gold',
    essencial: 'silver',
    free: 'free'
  }

  return tiposPlano[tipo.toLowerCase()] || 'free'
})

function exibirPlano(plano) {
  const valoresValidos = ['mensal', 'anual']
  return valoresValidos.includes(plano?.toLowerCase()) ? plano.toLowerCase() : ''
}

function formatarDataVencimento(dataVencimento) {
  if (!dataVencimento || isNaN(new Date(dataVencimento).getTime())) {
    return {
      dataFormatada: '--/--/----',
      diasRestantes: 'N/A'
    }
  }

  const data = new Date(dataVencimento)

  data.setDate(data.getDate() - 1)

  const dia = String(data.getDate()).padStart(2, '0')
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const ano = data.getFullYear()
  const dataFormatada = `${dia}/${mes}/${ano}`

  const hoje = new Date()
  const diferencaEmMilissegundos = data - hoje
  const diasRestantes = Math.ceil(diferencaEmMilissegundos / (1000 * 60 * 60 * 24))

  return {
    dataFormatada,
    diasRestantes
  }
}

watch(
  () => storePerfil.usuario,
  (novoUsuario) => {
    if (novoUsuario?.assinatura?.dataVencimento) {
      vencimento.value = formatarDataVencimento(novoUsuario.assinatura.dataVencimento)
    }
  },
  { immediate: true }
)
</script>

<style scoped>
section.aviso {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px;
  height: 80px;
  background-color: var(--cor-escuro-1);
  border-bottom: 2px solid var(--cor-escuro-2);
  position: relative;
  z-index: 4;
}
.foto {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin: 0 15px 0 0;
  z-index: 3;
}
.foto img {
  width: 20px;
  min-width: 20px;
  animation: zoom 2s ease-in-out infinite;
  filter: brightness(150%);
  z-index: 2;
}
.foto .fundo {
  position: absolute;
  width: 100%;
  height: 100%;
  width: 70px;
  height: 70px;
  background: linear-gradient(20deg, var(--degrade));
  animation: girando 3s linear infinite;
}
.foto.free .fundo {
  background: linear-gradient(20deg, #052a14, #0e6532, #159048);
}
.foto.silver .fundo {
  background: linear-gradient(20deg, #282a2f, #51545f, #7d8191);
}
.foto.gold .fundo {
  background: linear-gradient(20deg, #2c2704, #5d560b, #827311);
}
.foto.diamond .fundo {
  background: linear-gradient(20deg, #04162b, #12496e, #14638e);
}
.foto.unlimited .fundo {
  background: linear-gradient(20deg, #37030d, #5f0719, #77061d);
}
.texto {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 3;
}
.texto h3 svg {
  width: 10px;
  min-width: 10px;
  margin: 0 5px;
}
.texto h3 {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.texto p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
}
.texto h3 span {
  text-transform: capitalize;
}
@media screen and (max-width: 1000px) {
  section.aviso {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 20px;
    height: 80px;
    position: fixed;
    top: 50px;
    left: 0;
  }
  .foto {
    border-radius: 8px;
    margin: 0 10px 0 0;
  }
  .texto {
    flex-direction: column;
    align-items: flex-start;
  }
  .texto h3 {
    font-size: var(--f1);
  }
  .texto p {
    font-size: var(--f1);
    margin: 5px 0 0 0;
    width: 100%;
    max-width: 240px;
  }
}
</style>
